<!-- This button acts as a trigger to load Zendesk. When Zendesk is loaded, this will be hidden with the current chosen setup -->
<button
    appZendeskDirective
    [ngClass]="{
        loading: zendeskService.zendeskLoading$ | async,
        hidden: (zendeskService.zendeskChatIsOpen$ | async) || (zendeskService.zendeskScriptLoaded$ | async)
    }"
    *ngIf="platformService.isBrowser"
>
    <span class="content">
        <app-svg-icon class="icon" iconName="chat"></app-svg-icon>
        <span class="text">
            {{ 'customerService.zendesk.buttonText' | translateSafe }}
        </span>
    </span>
    <app-loading-dots class="spinner" *ngIf="zendeskService.zendeskLoading$ | async"></app-loading-dots>
</button>
